import styled from "styled-components";

interface ComponentProps {
  children: any;
  style?: any;
}

const Container = styled.p`
  color: ${(props) => props.theme.colors.title};
  font-size: 24px;
  font-weight: 700;
  margin-top: 24px;

  @media screen and (max-width: 470px) {
    font-size: 14px !important;
    margin-top: 12px;
  }
`;

const PageTitle: React.FC<ComponentProps> = ({ children, style }) => {
  return <Container style={style}>{children}</Container>;
};

export default PageTitle;
